function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.334 4L6 11.333 2.667 8",
  stroke: "#F2F6FA",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgExists = props => React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref);

export default SvgExists;